/**
 * A light haptic tick. Android gets navigator.vibrate; iOS Safari has no
 * vibrate, but since iOS 18 toggling an <input switch> plays the system
 * haptic, so we keep one hidden switch around and flip it. Must run inside a
 * user gesture (a tap or drag) to be felt; elsewhere it's a silent no-op.
 */
let label: HTMLLabelElement | null = null;

export function haptic(): void {
  try {
    if (typeof navigator.vibrate === "function" && navigator.vibrate(8)) return;
  } catch {
    // fall through to the switch trick
  }
  try {
    if (!label) {
      const input = document.createElement("input");
      input.type = "checkbox";
      input.setAttribute("switch", "");
      input.id = "cd-haptic";
      input.tabIndex = -1;
      label = document.createElement("label");
      label.htmlFor = input.id;
      const box = document.createElement("div");
      box.setAttribute("aria-hidden", "true");
      box.style.cssText = "position:fixed;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none;left:-9px;top:0";
      box.append(input, label);
      document.body.append(box);
    }
    label.click();
  } catch {
    // no haptics here; the visuals carry the feedback
  }
}
